export function getMandatoryPaymentAbTestUrl(nextStepUrl: string): string {
  let modifiedNextStepUrl = nextStepUrl

  if (nextStepUrl?.includes('/boeking-stap-4') || nextStepUrl?.includes('/stap-4')) {
    modifiedNextStepUrl = nextStepUrl
      .replace('/bookingpage', '/bookingpages')
      .replace('/boeking-stap-4', '/betaling')
      .replace('/stap-4', '/betaling')
  }

  return modifiedNextStepUrl
}

export function getMandatoryPaymentAbTestUdsUrl(nextStepUrl: string): string {
  let modifiedNextStepUrl = nextStepUrl

  if (nextStepUrl?.includes('/step-4-mandatory-payment-page')) {
    modifiedNextStepUrl = nextStepUrl.replace('/booking', '/bookings')
  }

  return modifiedNextStepUrl
}
